import Seo from "../components/Seo";
import { site } from "../config/site";

export default function Datenschutz() {
  return (
    <>
      <Seo title="Datenschutz" path="/datenschutz" />

      {/* Page-Header */}
      <section className="bg-primary text-white">
        <div className="mx-auto max-w-6xl px-4 py-16">
          <h1 className="text-5xl md:text-6xl font-extrabold uppercase">Datenschutz</h1>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 space-y-8 text-dark/80 text-sm leading-relaxed">
        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Verantwortliche Stelle</h2>
          <p>{site.name}</p>
          <p>{site.contact.address}</p>
          <p><a href={`mailto:${site.contact.email}`} className="text-primary hover:underline">{site.contact.email}</a></p>
        </div>

        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Erhobene Daten</h2>
          <p>
            Bei Nutzung des Kontaktformulars werden Name, E-Mail-Adresse, optionaler Betreff und Nachrichtentext
            übermittelt und ausschliesslich zur Bearbeitung der Anfrage verwendet. Es findet keine Weitergabe an Dritte statt.
          </p>
        </div>

        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Drittanbieter</h2>
          <p>
            Diese Website nutzt <strong>Firebase</strong> (Google LLC) — konkret Hosting, Authentifizierung,
            Datenbank (Firestore) und Cloud Functions — zum Betrieb des Webauftritts und des internen
            Redaktionssystems, sowie <strong>EmailJS</strong> zur sicheren Übermittlung von Formularanfragen.
            Diese Dienste verarbeiten Daten auf Servern in den USA bzw. der EU. Es gelten die jeweiligen
            Datenschutzrichtlinien der Anbieter.
          </p>
        </div>

        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Redaktionssystem (CMS-Zugang)</h2>
          <p>
            Für die Pflege der Website-Inhalte (News, Teams, Sponsoren) nutzt {site.shortName} ein internes
            Redaktionssystem mit passwortlosem E-Mail-Login. Die E-Mail-Adressen der Redaktionsmitglieder werden
            dafür in Firebase Authentication und in der Firestore-Datenbank (Google LLC) gespeichert — ausschliesslich
            zur Zugriffsverwaltung, nicht für Werbezwecke und nicht an Dritte weitergegeben. Die Löschung erfolgt
            auf Anfrage der betroffenen Person oder wenn die Mitarbeit im Redaktionsteam endet.
          </p>
        </div>

        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Cookies und Tracking</h2>
          <p>
            Diese Website verwendet keine Tracking-Cookies und kein Google Analytics. Es werden keine personenbezogenen
            Daten für Werbezwecke erhoben oder weitergegeben.
          </p>
        </div>

        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Ihre Rechte (revDSG)</h2>
          <p>
            Sie haben das Recht auf Auskunft, Berichtigung und Löschung Ihrer gespeicherten Daten. Anfragen richten Sie
            bitte an: <a href={`mailto:${site.contact.email}`} className="text-primary hover:underline">{site.contact.email}</a>
          </p>
        </div>

        <p className="text-xs text-dark/40 border-t border-black/10 pt-6">
          Hinweis: Diese Datenschutzerklärung dient als Vorlage und ersetzt keine Rechtsberatung.
          Vor Live-Schaltung empfiehlt sich eine Prüfung durch einen Rechtsanwalt.
        </p>
      </section>
    </>
  );
}
